export type ThemeColor = 'sunsetEmber' | 'classicNoir';

export const ThemeColor: Record<ThemeColor, ThemeColor> = {
  sunsetEmber: 'sunsetEmber',
  classicNoir: 'classicNoir',
};

export const ThemeColorLabel: Record<ThemeColor, string> = {
  sunsetEmber: 'page.setting.sunset-ember',
  classicNoir: 'page.setting.classic-noir',
};

export const THEME_PREVIEW_FOREGROUND_IMAGES: Record<ThemeColor, string> = {
  sunsetEmber: 'https://goodchart-public.s3.ap-southeast-2.amazonaws.com/sunset_ember_foreground.png',
  classicNoir: 'https://goodchart-public.s3.ap-southeast-2.amazonaws.com/black_noir_foreground.png',
};

export interface Theme {
  id: ThemeColor;
  name: string;
  type: string;
  image: string;
  isDefault: boolean;
  // colors?: ThemeColors;
}
